export var groupItemTheme = {
  baseStyle: _ref => {
    var {
      order,
      grow: flexGrow,
      shrink: flexShrink,
      basis: flexBasis,
      alignSelf
    } = _ref;
    return {
      order,
      flexGrow,
      flexShrink,
      flexBasis,
      alignSelf,
      // `minWidth` is necessary for text-ellipsis to work
      minWidth: 0
    };
  }
};
//# sourceMappingURL=GroupItem.theme.js.map